import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="propora-container py-28 text-center" data-testid="not-found-page">
      <p className="font-display font-extrabold text-7xl text-[#007F83]">404</p>
      <h1 className="font-display font-extrabold text-3xl text-[#0B1733] mt-4">Page not found</h1>
      <p className="text-[#4A5568] mt-2">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/"><Button className="mt-6 rounded-full bg-[#007F83] hover:bg-[#006B70] text-white h-11 px-7">Back to home</Button></Link>
    </div>
  );
}
